import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { Button, FormControl, Modal, Spinner, Table } from "react-bootstrap";

import {
  downloadEnquiry,
  enquiry,
} from "../../../store/actions/councilActions/enquiryAction";
import BreadCrumb from "../../BreadCrumb";
import Pagination from "../../misc/Pagination";
const breadcrumbs = [
  {
    path: "/admin/dashboard",
    label: "Dashboard",
  },
  {
    label: "Affiliation Enquiry",
  },
];
const AffiliationEnquiry = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [activePage, setactivePage] = useState(1);
  const [totalPages, settotalPages] = useState(0);
  const [search, setSearch] = useState("");
  const [viewRow, setViewRow] = useState(null);

  const fetchData = useCallback(async () => {
    const response = await dispatch(
      enquiry("affiliation", activePage, "", "", search)
    );
    if (response) {
      setData(response.data);
      setLoading(false);
      settotalPages(Math.ceil(response.total / response.per_page));
    } else {
      setLoading(false);
    }
  }, [activePage, dispatch, search]);
  useEffect(() => {
    setLoading(true);
    fetchData();
  }, [fetchData]);

  const handleDownload = () => {
    dispatch(downloadEnquiry("affiliation"));
  };

  return (
    <div>
      <div class="subheader py-2 py-lg-6 subheader-solid" id="kt_subheader">
        <div class="container-fluid d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
          <BreadCrumb crumbs={breadcrumbs} />

          <div class="d-flex align-items-center">
            <button
              onClick={handleDownload}
              className="btn btn-light-primary font-weight-bolder btn-sm"
            >
              Download list
            </button>
            <Link
              to="/admin/enquiry/admission"
              class="btn btn-light-primary font-weight-bolder btn-sm"
            >
              Admission Enquiry
            </Link>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row mb-4">
          <div className="col-md-5">
            <FormControl
              type="search"
              placeholder="Search name, mobile, email, city, message..."
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setactivePage(1);
              }}
            />
          </div>
        </div>
        {loading ? (
          <div className="text-center">
            <Spinner animation="border" role="status" size="lg">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <Table bordered hover striped responsive className="mb-0">
            <thead>
              <th>S No</th>
              <th>Date</th>
              <th>Name</th>
              <th>Mobile</th>
              <th>Trade</th>
              <th>Details</th>
            </thead>
            <tbody>
              {data.length === 0 ? (
                <tr>
                  <td colSpan={6} className="text-center text-danger">
                    No Record Found
                  </td>
                </tr>
              ) : (
                data.map((e, index) => (
                  <tr>
                    <td>{(activePage - 1) * 10 + index + 1}</td>
                    <td>
                      {e.created_at
                        ? moment(e.created_at).format("DD/MM/YYYY")
                        : "--"}
                    </td>
                    <td>{e.name}</td>
                    <td>{e.mobile}</td>
                    <td>{e.trade?.name}</td>
                    <td>
                      <button
                        type="button"
                        class="btn btn-sm btn-light-primary"
                        onClick={() => setViewRow(e)}
                      >
                        View
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        )}
        {totalPages && Number(totalPages) !== 0 ? (
          <Pagination
            setActivePage={(value) => setactivePage(value)}
            totalPages={totalPages}
          />
        ) : null}
      </div>

      <Modal show={!!viewRow} onHide={() => setViewRow(null)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Enquiry Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {viewRow && (
            <table className="table table-bordered mb-0">
              <tbody>
                <tr><th style={{ width: "35%" }}>Date</th><td>{viewRow.created_at ? moment(viewRow.created_at).format("DD/MM/YYYY hh:mm A") : "--"}</td></tr>
                <tr><th>Name</th><td>{viewRow.name || "--"}</td></tr>
                <tr><th>Mobile</th><td>{viewRow.mobile || "--"}</td></tr>
                <tr><th>Email</th><td>{viewRow.email || "--"}</td></tr>
                <tr><th>Trade</th><td>{viewRow.trade?.name || "--"}</td></tr>
                <tr><th>Address</th><td>{viewRow.address || "--"}</td></tr>
                <tr><th>City</th><td>{viewRow.city || "--"}</td></tr>
                <tr><th>State</th><td>{viewRow.state || "--"}</td></tr>
                <tr><th>Message</th><td>{viewRow.message || "--"}</td></tr>
              </tbody>
            </table>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => setViewRow(null)}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AffiliationEnquiry;
